import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Entropy extends Bloc {

	constructor (src, ctx) {

		super("entropy", src, ctx);
		this.f = (src, ins) => [src.master.run.minDeckSize];
		this.types = [];
	}
}